module.exports = __webpack_public_path__ + "img/tr.d0bf34a0.svg";